import React, { MouseEventHandler, PropsWithChildren } from 'react'

import { ReactComponent as CheckCircleFilledIcon } from '@app/assets/Small/Filled/CheckCircle.svg'
import { ReactComponent as InfoFilledIcon } from '@app/assets/Small/Filled/Info.svg'
import { ReactComponent as WarningFilledIcon } from '@app/assets/Small/Filled/Warning.svg'
import { bemJoin } from '@app/lib/bem'

import './Alert.scss'

export enum AlertType {
  error = 'error',
  success = 'success',
  info = 'info'
}

export type AlertProps = {
  type: AlertType
  onClick?: MouseEventHandler
}

const b = bemJoin('lawyer-alert')

export const Alert = ({ type, onClick, children }: PropsWithChildren<AlertProps>) => {
  return (
    <div className={b({ [type]: true, clickable: !!onClick })} onClick={onClick}>
      <div className={b('icon')}>
        <AlertIcon type={type} />
      </div>
      <div className={b('message')}>{children}</div>
    </div>
  )
}

const AlertIcon = ({ type }: { type: AlertType }) => {
  switch (type) {
    case AlertType.error:
      return <WarningFilledIcon data-testid='warning-icon' />
    case AlertType.success:
      return <CheckCircleFilledIcon data-testid='check-circle-icon' />
    case AlertType.info:
      return <InfoFilledIcon data-testid='info-icon' />
  }
}
